import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AdminGuard } from '../calvin-emr-shared/guards/admin.guard';
import { AuthGuard } from '../calvin-emr-shared/guards/auth.guard';
import { MedicationsPageComponent } from './medications-page/medications-page.component';
import { PATH_MEDICATIONS } from './medications.global';
import { PATH_PATIENTS } from 'src/app/patients/patients.global';
import { PATH_LOGIN } from 'src/app/login/login.global';

export const medicationsRoutes: Routes = [
  {
    path: PATH_MEDICATIONS,
    component: MedicationsPageComponent,
    canActivate: [
      () => inject(AuthGuard).canActivate(PATH_LOGIN),
      () => inject(AdminGuard).canActivate(PATH_PATIENTS),
    ],
  },
];
